import { configureStore, combineReducers } from '@reduxjs/toolkit';
// Removed storage import as persistence is disabled
// import storage from 'redux-persist/lib/storage';
import agentsReducer from './agents';
import activitiesReducer from './activities';
import activityRecordsReducer from './activityRecords';
import messagesReducer from './messages';

// const agentsPersistConfig = {
//   key: 'agents',
//   storage,
//   whitelist: ['agents'],
// };
//
// const activitiesPersistConfig = {
//   key: 'activities',
//   storage,
//   whitelist: ['items', 'cursorsByAgent', 'loadedAgents'],
// };
//
// const activityRecordsPersistConfig = {
//   key: 'activityRecords',
//   storage,
//   whitelist: ['items', 'loadedActivities'],
// };

// const rootReducer = combineReducers({
//   agents: persistReducer(agentsPersistConfig, agentsReducer),
//   activities: persistReducer(activitiesPersistConfig, activitiesReducer),
//   activityRecords: persistReducer(
//     activityRecordsPersistConfig,
//     activityRecordsReducer,
//   ),
//   messages: messagesReducer,
// });

const rootReducer = combineReducers({
  agents: agentsReducer,
  activities: activitiesReducer,
  activityRecords: activityRecordsReducer,
  messages: messagesReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Paths to ignore for serializability check due to use of Map/Set
        ignoredPaths: [
          'activities.items',
          'activities.cursorsByAgent',
          'activities.loadedAgents',
          'activityRecords.items',
          'activityRecords.loadedActivities',
        ],
      },
    }),
});

// export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
